import React, { useCallback } from 'react';
import Select, { components } from 'react-select-v3';
import VehicleImage from 'components/VehicleImage';
import { reactSelectStyles } from 'utils/style';
import { MenuList } from 'utils/select';

const SingleValue = ({ children, ...props }) => {
  const { data: vehicle } = props;
  const { vehicle_type } = vehicle || {};

  return (
    <components.SingleValue {...props}>
      <VehicleImage type={vehicle_type} size="2.5rem" color="grey700" /> - {children}
    </components.SingleValue>
  );
};

const Option = ({ children, ...props }) => {
  const { data: vehicle } = props;
  const { vehicle_type } = vehicle || {};

  return (
    <components.Option {...props}>
      <VehicleImage type={vehicle_type} size="2.5rem" color="grey700" /> - {children}
    </components.Option>
  );
};

const VehicleSelect = ({
  options = [],
  onChange = () => {
    /*noop*/
  },
  onKeyDown = () => {
    /*noop*/
  },
  placeholder,
  disabled,
  value,
  ...props
}) => {
  const getOptionLabel = useCallback((option) => {
    return option.plate_number;
  }, []);

  const getOptionValue = useCallback((option) => {
    return option.id;
  }, []);

  return (
    <Select
      isClearable
      placeholder={placeholder}
      value={value}
      onChange={onChange}
      options={options}
      styles={reactSelectStyles}
      onKeyDown={onKeyDown}
      isDisabled={disabled}
      getOptionLabel={getOptionLabel}
      getOptionValue={getOptionValue}
      components={{ SingleValue, Option, MenuList }}
      closeMenuOnSelect
      menuPortalTarget={document.body}
      {...props}
    />
  );
};

export default VehicleSelect;
